<template>
  <div>
    <!-- Lien vers une URL -->
    <template v-if="link.link_type=='url'">
      <a :class="classData" :href="link.link_url" target="_blank">
        <span v-html="htmlBefore"></span>{{link.link_title}}<span v-html="htmlAfter"></span>
      </a>
    </template>

    <!-- Lien vers un document interne au site -->
    <template v-else-if="link.link_type=='doc_in'">
      <!-- fichier -->
      <template v-if="link.link_doc_type=='file'">
        <a :class="classData" :href="link.link_doc_file.url" target="_blank">
          <span v-html="htmlBefore"></span> {{link.link_title}}<span v-html="htmlAfter"></span>
        </a>
      </template>
      <!-- Image -->
      <template v-else-if="link.link_doc_type=='image'">
        <img :class="classData" :src="link.link_doc_image.url" :alt="link.link_doc_image.alt">
      </template>
    </template>

    <!-- Lien vers une page interne au site -->
    <template v-else-if="link.link_type=='page'">
      <a :class="classData" :href="getLinkUrl(link)">
        <span v-html="htmlBefore"></span> {{link.link_title}} <span v-html="htmlAfter"></span>
      </a>
    </template>

    <!-- Lien vers une route interne -->
    <template v-else-if="link.link_type=='route'">
      <router-link :class="classData" :to="{name: link.link_route, params:  getTabToRouteData(link.link_params), queries: getTabToRouteData(link.link_queries) }">
        <span v-html="htmlBefore"></span> {{link.link_title}} <span v-html="htmlAfter"></span>
      </router-link>
    </template>

  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  props: {
    link: {
        type: Object,
        default: function () {
          return { link_type : '' };
        }
    },
    htmlBefore: {
      type: String,
      default: ""
    },
    htmlAfter: {
      type: String,
      default: ""
    },
    classData: {
      type: String,
      default: ""
    }
  },
  methods: {
    /* transforme un tableau de paramètres au format de paramètres URL. */
    getTabToUrlParams(tableObject) {
      let tab = [];

      if(tableObject != null) {
        for(let i = 0; i < tableObject.length; ++i) {
          // vérification du format de la donée initiale
          if(tableObject[i].length == 2) {
            // recupération des valeurs des paramètres
            tab.push(tableObject[i][1]);
          }
        }
      }

      return tab.join("/");
    },
    getTabToUrlQueries(tableObject) {
      let tab = [];

      if(tableObject != null) {
        for(let i = 0; i < tableObject.length; ++i) {
          // vérification du format de la donée initiale
          if(tableObject[i].length == 2) {
            // recupération des valeurs des paramètres
            tab.push(tableObject[i][0] + '=' + tableObject[i][1]);
          }
        }
      }

      return tab.join("&");
    },
    /* transforme un tableau de paramètres au format de paramètres URL. */
    getTabToRouteData(tableObject) {
      let element = {};

      if(tableObject && tableObject.body) {
        for(let i = 0; i < tableObject.body.length; ++i) {
          // vérification du format de la donnée initiale
          if(tableObject.body[i].length == 2) {
            // recupération des valeurs des paramètres
            element[ tableObject.body[i][0].c ] = tableObject.body[i][1].c;
          }
        }
      }

      return element;
    },
    getLinkAnchored(link, hasAnchor, anchorValue) {

      let link_filtered = this.linkFilter(link);
      if(hasAnchor == true) {
        link_filtered += '#' + anchorValue;
      }
      return link_filtered;
    },
    getLinkUrl(data) {
      let url = this.getLinkAnchored(data.link_page, data.add_anchor, data.anchor_value);
      if(data.add_params == true) {
        url += '/' + this.getTabToUrlParams(data.link_params.body);
      }
      if(data.add_queries == true) {
        url += '?' + this.getTabToUrlQueries(data.link_queries.body);
      }
      return url;
    },
    /* Filtre et retire le "/" en fin d'une URL */
    linkFilter(link_url) {
      const len = link_url.length;

      if((len > 0) && link_url[len-1] =="/") {
        return link_url.substring(0,link_url.length-1);
      } else {
        return link_url;
      }
    }
  }

}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/shared/DynamicLinker.vue